import React from 'react'
import { connect } from 'react-redux'

const SelectEvent = ({ events, state, onChange }) => {
  const eventList = events.map((event, i) => 
    <option value={i} key={i}>{event.name}</option>
  )
  return (
    <select className="input select">
      <option value="">Select Event</option>
      {eventList}
    </select>
  )
}

function mapStateToProps(state) {
  return { events: state.events }
}

export default connect(mapStateToProps, null)(SelectEvent)


// WEBPACK FOOTER //
// ./src/components/micro/SelectEvent.js